import { render, staticRenderFns } from "./agenturen.vue?vue&type=template&id=3bfdf82e"
import script from "./agenturen.vue?vue&type=script&lang=js"
export * from "./agenturen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports